import { effectiveResearchDocs } from '../measurementSignals/effectiveResearchIds'

// AI-CONTEXT: See docs/features/automatische-deelname-onderzoek.md

/**
 * De doelgroep die een medewerker via zijn onderzoek al heeft.
 *
 * Een onderzoek hangt aan één doelgroep uit de Theory of Change. Doet een
 * medewerker aan dat onderzoek mee — via 'Geldt voor alle medewerkers' of met
 * de hand gekoppeld — dan is dát de voor de hand liggende doelgroep, en hoeft
 * niemand hem nog per medewerker te kiezen. Het eerste onderzoek met een
 * doelgroep telt, in de volgorde van `effectiveResearchDocs` (handmatig eerst).
 *
 * Alleen een voorstel voor het scherm: dit schrijft niets. Kiest de gebruiker
 * zelf een andere doelgroep, dan wint die.
 *
 * @param {object} [args]
 * @param {Array<string>} [args.linkedIds] - `Personas.Research`
 * @param {Array<object>|null} [args.researches] - Alle `Research`-documenten (op Position)
 * @returns {{stakeholderId: string, researchTitle: string}|null} `null` als er niets af te leiden is
 */
const defaultTargetgroupFromResearch = ({ linkedIds, researches } = {}) => {
    const withTargetgroup = effectiveResearchDocs({ kind: 'persona', linkedIds, researches })
        .find((research) => typeof research.TargetgroupID === 'string' && research.TargetgroupID !== '')
    if (!withTargetgroup) return null
    return { stakeholderId: withTargetgroup.TargetgroupID, researchTitle: withTargetgroup.Title || '' }
}

export default defaultTargetgroupFromResearch
